module.exports = __webpack_public_path__ + "img/herov2.1a2da309.jpg";